import type { Menu } from '#/global'
import type { RouteRecordRaw } from 'vue-router'
import { resolveRoutePath } from '@/utils'

/** 将路由树转换为菜单树，并按路由元数据隐藏指定中间层。 */
export function convertRouteToMenuRecursive(routes: RouteRecordRaw[], basePath = ''): Menu.recordRaw[] {
  const returnMenus: Menu.recordRaw[] = []
  routes.forEach((item) => {
    // 保留路由中间层用于布局和路由注册，但在菜单中直接展示其子菜单。
    if (item.meta?.menuFlatten && item.children) {
      returnMenus.push(...convertRouteToMenuRecursive(item.children, resolveRoutePath(basePath, item.path)))
      return
    }

    const menuItem: Menu.recordRaw = {
      path: typeof item.meta?.menuPath === 'string'
        ? item.meta.menuPath
        : resolveRoutePath(basePath, item.path),
      meta: {
        title: item?.meta?.title,
        icon: item?.meta?.icon,
        activeIcon: item?.meta?.activeIcon,
        defaultOpened: item?.meta?.defaultOpened,
        alwaysOpened: item?.meta?.alwaysOpened,
        auth: item?.meta?.auth,
        menu: item?.meta?.menu,
        badge: item?.meta?.badge,
        badgeVariant: item?.meta?.badgeVariant,
        newWindow: item?.meta?.newWindow,
        link: item?.meta?.link,
        query: item?.meta?.query,
      },
    }
    if (item.children) {
      menuItem.children = convertRouteToMenuRecursive(item.children, menuItem.path)
    }
    returnMenus.push(menuItem)
  })
  return returnMenus
}
